import React, { useEffect } from "react";
import SubLeftMenu from "containers/SubLeftMenu/SubLeftMenu.container";
import ProductOverview from "./ProductOverview/ProductOverview";
import styled from "styled-components";
import { Switch, Route, useRouteMatch, useParams } from "react-router-dom";
import {
  clearSelectedProductLine,
  getProductLine,
} from "../../../../store/reducers/products/products.actions";
import {
  getProductValueAttributes,
  getProductLineTagsCount,
  getProductRulesets,
} from "../../../../store/reducers/products/parameters/parameters.actions";
import { useDispatch } from "react-redux";
import ProductLinePVAs from "./ProductLineParameters/ProductLinePVAs";
import ProductLineRulesets from "./ProductLineParameters/ProductLineRulesets";
import ProductLineTags from "./ProductLineParameters/ProductLineTags";
import ProductLineProperties from "./ProductLineProperties/ProductLineProperties";
import ProductLineRulesTables from "./ProductLineRulesTables/ProductLineRulesTables";
import TableSummaryPanel from "./TableSummary/TableSummaryPanel";
import { setPropertiesInitialState } from "../../../../store/reducers/products/properties/pl-properties.actions";
import { setTablesInitialState } from "../../../../store/reducers/products/tables/tables.actions";
import ProductCandidateSelection from "./ProductCandidateSelection/ProductCandidateSelection.page";
import ProductMetadataPage from "./ProductMetadata/ProductMetadata.page";
import { PropertyPrioritiesList } from "./PropertyPrioritiesList/PropertyPrioritiesList.component";
import { clearPropertyPrioritiesList } from "../../../../store/reducers/products/propertyPriorities/pl-propertyPriorities.action";
import { useTypedSelector } from "../../../../store";
import MacrosPage from "./Macros/MacrosPage";
import { setRestVerb } from "store/reducers/generalActions";

const menuItems = [
  {
    path: "overview",
    label: "Overview",
    content: <ProductOverview />,
  },
  {
    path: "rulesets",
    label: "Rulesets",
    content: <ProductLineRulesets />,
  },
  {
    path: "tags",
    label: "Tags",
    content: <ProductLineTags />,
  },
  {
    path: "pvas",
    label: "Property Value Attributes",
    content: <ProductLinePVAs />,
  },
  // {
  //   path: "logic-groups",
  //   label: "Logic Groups",
  //   content: <ProductLineLogicGroups />,
  // },
  {
    path: "properties",
    label: "Properties",
    content: <ProductLineProperties />,
  },
  {
    path: "rules-tables",
    label: "Tables",
    content: <ProductLineRulesTables />,
  },
  {
    path: "table-summary",
    label: "Table Summary",
    content: <TableSummaryPanel />,
  },
  {
    path: "property-priorities-list",
    label: "Property Priority Lists",
    content: <PropertyPrioritiesList />,
  },
  {
    path: "selection-candidate-list",
    label: "Selection Candidate Config",
    content: <ProductCandidateSelection />,
  },
  {
    path: "Metadata",
    label: "Metadata Config",
    content: <ProductMetadataPage />,
  },
  {
    path: "Macros",
    label: "Macros",
    content: <MacrosPage />,
  },
];

export default function ProductDetail() {
  const { path: rootPath } = useRouteMatch();
  const { productLineId } = useParams<{ productLineId: string }>();
  const dispatch = useDispatch();

  const gettingProductLine = useTypedSelector(
    (state) => state.products.getting
  );

  useEffect(() => {
    const fetchProductLineData = async () => {
      dispatch(setRestVerb("products", true, "getting"));
      await dispatch(getProductLine(productLineId));
      dispatch(getProductValueAttributes());
      dispatch(getProductLineTagsCount());
      dispatch(getProductRulesets());
      dispatch(setRestVerb("products", false, "getting"));
    };

    fetchProductLineData();

    return () => {
      dispatch(clearSelectedProductLine());
      dispatch(setPropertiesInitialState());
      dispatch(setTablesInitialState());
      dispatch(clearPropertyPrioritiesList());
    };
  }, []);

  return (
    <Wrapper>
      <StyledSubLeftMenu menuItems={menuItems} />
      <PageContent id="product-lines-wrapper">
        <Switch>
          {menuItems.map(({ path, content }) => {
            return (
              <Route key={path} exact path={`${rootPath}/${path}`}>
                {/* put the corresponding page into the "content" property of the menuItems object */}
                {!gettingProductLine && content}
              </Route>
            );
          })}
        </Switch>
      </PageContent>
    </Wrapper>
  );
}

const Wrapper = styled.div`
  display: flex;
  flex-flow: row nowrap;
  justify-content: space-between;
  width: 100%;
  /* Fill remaining Layout main area below the header (not a fixed 90vh,
     which left growing empty space under the grid on tall windows). */
  flex: 1 1 auto;
  min-height: 0;
  height: 100%;
  overflow: hidden;
`;

const StyledSubLeftMenu = styled(SubLeftMenu)`
  overflow: hidden;
  flex: 0 0 auto;
  display: flex;
  position: fixed;
  top: 0;
  left: 0;
  bottom: 0;
`;

const PageContent = styled.div`
  flex: 1 1 auto;
  min-width: 1050px;
  min-height: 0;
  height: 100%;
  display: flex;
  flex-direction: column;
  overflow: auto;
`;
